import chevron from '@/services/chevron';

const BASE_URL = `${import.meta.env.VITE_API_STARGATE}/builder4`;

export type BrandProfileResponse = {
  id: string;
  name: string;
  data: Record<string, unknown>;
  globalStyleId: string | null;
  createdAt: string;
  updatedAt: string;
};

export type BrandProfileGenerationPollResponse =
  | { status: 'pending' }
  | { status: 'ready'; brandProfile: BrandProfileResponse }
  | { status: 'failed'; error?: string };

export type QuotaResponse = {
  used: number;
  limit: number;
};

export type PageGenerationPollResponse =
  | { status: 'pending' }
  | { status: 'completed'; pageId: string }
  | { status: 'failed'; error?: string };

const JSON_HEADERS = { 'Content-Type': 'application/json' } as const;

export const fetchBrandProfiles = async (): Promise<BrandProfileResponse[]> => {
  return (await chevron.http({
    url: `${BASE_URL}/brand-profiles`,
    method: 'GET',
    headers: JSON_HEADERS,
  })) as BrandProfileResponse[];
};

export const startBrandProfileGeneration = async (websiteUrl: string): Promise<{ id: string }> => {
  return (await chevron.http({
    url: `${BASE_URL}/brand-profiles/generate`,
    method: 'POST',
    headers: JSON_HEADERS,
    body: { websiteUrl },
  })) as { id: string };
};

export const pollBrandProfileGeneration = async (
  sessionId: string,
): Promise<BrandProfileGenerationPollResponse> => {
  return (await chevron.http({
    url: `${BASE_URL}/brand-profiles/generate/${sessionId}`,
    method: 'GET',
    headers: JSON_HEADERS,
  })) as BrandProfileGenerationPollResponse;
};

export const fetchQuota = async (): Promise<QuotaResponse> => {
  return (await chevron.http({
    url: `${BASE_URL}/pages/generate/quota`,
    method: 'GET',
    headers: JSON_HEADERS,
  })) as QuotaResponse;
};

export const startPageGeneration = async (params: {
  brandProfileId: string | null;
  globalStyleId: string | null;
  goal: string;
  description: string;
}): Promise<{ id: string }> => {
  return (await chevron.http({
    url: `${BASE_URL}/pages/generate`,
    method: 'POST',
    headers: JSON_HEADERS,
    body: {
      brand_profile_id: params.brandProfileId,
      global_style_id: params.globalStyleId,
      goal: params.goal,
      description: params.description,
    },
  })) as { id: string };
};

export const pollPageGeneration = async (jobId: string): Promise<PageGenerationPollResponse> => {
  return (await chevron.http({
    url: `${BASE_URL}/pages/generate/${jobId}`,
    method: 'GET',
    headers: JSON_HEADERS,
  })) as PageGenerationPollResponse;
};
